import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api-client.js';
import { DEFAULT_STORE_CONFIG } from '@store/shared';

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [storeConfig, setStoreConfig] = useState(DEFAULT_STORE_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadConfig() {
      try {
        const response = await api.getStoreConfig();
        if (isMounted && response?.data) {
          setStoreConfig(response.data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err);
          // Keep default store config as safe fallback
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadConfig();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <StoreContext.Provider value={{ storeConfig, loading, error }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}
